import api from '../lib/api'
import initialState from '../state'

export const SET_SEGMENT = 'export-tool/segments/set-segment'
export const FETCH_SEGMENTS = 'export-tool/segments/fetch-segments'
export const RECEIVE_SEGMENTS = 'export-tool/segments/receive-segments'
export const RESET_SEGMENTS = 'export-tool/segments/reset-segments'

export default function reducer(state = {...initialState.segments}, action = {}) {
  const newState = {...state}
  switch (action.type) {
    case SET_SEGMENT:
      newState.selected = action.payload.segment
      return newState
      break

    case FETCH_SEGMENTS:
      newState.fetched = false
      newState.fetching = true
      return newState
      break

    case RECEIVE_SEGMENTS:
      newState.fetched = true
      newState.fetching = false
      newState.list = action.payload.segments
      return newState
      break

    case RESET_SEGMENTS:
      return {
        fetching: false,
        fetched: false,
        list: [],
        selected: null,
      }
      break

    default:
      return state
      break
  }
}

export function setSegment(segment) {
  return {
    type: SET_SEGMENT,
    payload: {
      segment
    }
  }
}

export function resetSegments() {
  return {
    type: RESET_SEGMENTS,
    payload: null
  }
}

export function fetchSegments(token, projectId) {
  return (dispatch) => {
    dispatch({ type: FETCH_SEGMENTS, payload: null })
    api
    .segments(token, projectId)
    .then(segments => {
      dispatch(receiveSegments(segments))
    })
    .catch(err => {
      dispatch(receiveSegments([]))
      console.error(`[fetchSegments] error fetching segments: ${err.message}`)
    })
  }
}

export function receiveSegments(segments) {
  return {
    type: RECEIVE_SEGMENTS,
    payload: {
      segments
    }
  }
}



// WEBPACK FOOTER //
// ./ducks/segments.js